// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024-2025 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard.js';

export default [
    {
        path: [config.routes.certificationSessions.mySessions],
        guard: getPermissionsGuard([{ resource: 'portal.my-session', scopes: ['view'] }]),
        controller: () => import('./controllers/mySessions')
    },
    {
        path: [config.routes.certificationSessions.enrollmentSessions],
        guard: getPermissionsGuard([
            { resource: 'portal.my-session', scopes: ['view', 'self-enrol'] },
            { resource: 'portal.payment', scopes: ['create'] }
        ]),
        controller: () => import('./controllers/enrollmentSessions')
    },
    {
        path: [config.routes.certificationSessions.myAssignedSessions],
        guard: getPermissionsGuard([{ resource: 'portal.staff-member-session-room', scopes: ['view', 'create'] }]),
        controller: () => import('./controllers/myAssignedSessions')
    }
];
